var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"back-to-top",class:[_vm.activeClass],on:{"click":_vm.scrollTop}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }